import React from "react";
import { Button as Btn } from "reactstrap";
import { PulseLoader } from "react-spinners";
import PropTypes from "prop-types";

const Button = ({
  disabled,
  loading,
  text,
  children,
  loadingIndicatorSize,
  loadingIndicatorColor,
  ...othersProps
}) => (
  <Btn
    className="text-white saddd"
    {...othersProps}
    disabled={disabled || loading}
  >
    {loading ? (
      <PulseLoader size={loadingIndicatorSize} color={loadingIndicatorColor} />
    ) : (
      children || text
    )}
  </Btn>
);

Button.propTypes = {
  text: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  loadingIndicatorSize: PropTypes.number,
  loadingIndicatorColor: PropTypes.string,
  children: PropTypes.any
};

Button.defaultProps = {
  text: null,
  loading: false,
  disabled: false,
  loadingIndicatorSize: 10,
  loadingIndicatorColor: "#fff",
  children: null
};

export default Button;
